import { createFileRoute } from '@tanstack/react-router'
import { SolicitudFirmaScreen } from '@web/app/features/firmas'
import { PenLine } from '@tamagui/lucide-icons'

export const Route = createFileRoute('/_index/documents/sign')({
  component: SolicitudFirmaScreen,
  staticData: {
    metaRoute: {
      title: 'Firmar',
      order: 2,
      icon: PenLine,
    },
  },
})